"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var action_1 = require("../action");
var handlers = {};
function stitch(next, action, actionType, args, actionContext) {
    var returnValue = next(action, actionType, args, actionContext);
    if (actionType && handlers[actionType]) {
        handlers[actionType].forEach(function (handler) { return handler.apply(null, args); });
    }
    return returnValue;
}
exports.stitch = stitch;
function subscribe(actionType, callback) {
    if (!handlers[actionType]) {
        handlers[actionType] = [];
    }
    handlers[actionType].push(callback);
}
exports.subscribe = subscribe;
function raise(actionType, callback) {
    console.error("[satcheljs-stitch] The 'raise' API is deprecated.  Use 'raiseAction' instead.");
    var actionToExecute = action_1.default(actionType)(function () { });
    if (callback) {
        callback(actionToExecute);
    }
    else {
        actionToExecute();
    }
}
exports.raise = raise;
function raiseAction(actionType) {
    return action_1.default(actionType)(function () { });
}
exports.raiseAction = raiseAction;
